<template>
    <div>
        <div class="mb-3">
            <package :onhistory="onhistory" @onhistory="$emit('onhistory')"/>
        </div>
        <div class="mb-3">
            <invoice :onhistory="onhistory" @onhistory="$emit('onhistory')"/>
        </div>
    </div>
</template>
<script>
import Package from './history/Package'
import Invoice from './history/Invoice'
export default {
    props: ['onhistory'],
    components: { Package, Invoice }
}
</script>